module.exports = __webpack_public_path__ + "static/media/BottomHome.3c1a9d8c.svg";